<!--  -->
<template>
  <div class='app' id="app">
    <router-view v-if="!$route.meta.keep"/>
    <keep-alive>
      <router-view v-if="$route.meta.keep" :key="$route.fullPath"/>
    </keep-alive>
  </div>
</template>

<script>
import { isWeiXin } from '@/utils/index'

export default {
  components: {},
  data() {
    return {
      
    };
  },
  computed: {},
  watch: {
    
  },
  created() {
    // this.setWxConfig()
    // window.localStorage.setItem('token', "RFlabkRWTUh3d0NzeUtDck9KZ3J1NkdFdXBQMmNjV2lRM1dmYW9UZg.D8Faqn9WxZ_A649hbrMlwwe1BdoWvJjqsxu_abV0qmIQvLSE")
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  //方法集合
  methods: {
    // 微信配置
    setWxConfig ( ) {
      let token = window.localStorage.getItem('token')
      if (isWeiXin() && token) {
        if (window.location.search) {
          let code = window.location.search.split('=')[1].split('&')[0] || ''
          this.$http({
            method: 'post',
            data: {
              c: 'user/set_openid',
              code: code
            }
          }).then(res => {
            if (res.code == 10006) {
              this.getWxConfig()
            } else {
              console.log('openid获取失败')
            }
          })
        } else {
          this.getWxConfig()
        }
      } else if (isWeiXin()) {
        this.getWxConfig()
      }
    },
    getWxConfig () {
      let url = window.location.href.split('#')[0]
      this.$http({
        method: 'post',
        data: {
          c: 'Home/index/js_config',
          url: url,
        }
      }).then(res => {
        this.$wx.config({
          debug: res.data.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature,// 必填，签名
          jsApiList: res.data.jsApiList // 必填，需要使用的JS接口列表
        });

        let that = this
        this.$wx.ready(function(){
          let code = ''
          if ( window.location.search.indexOf('=') != -1) {
            code = window.location.search.split('=')[1].split('&')[0] || ''
            if (code) {
              window.location.href = window.location.protocol + '//' + window.location.host
            }
          }
          that.$nextTick(() => {
            that.getShare()
          })
        });
        this.$wx.error(function(err) {
          console.log(err, '微信配置失败')
        })
      })
    },
  },
}
</script>

<style lang='less' scoped>

</style>